import React from 'react';
import Error from '../Error/NewError';

const NotSupportedBrowser = () => {
    const errorToDisplay = {
        hasError : true,
        title : "Przeglądarka, której używasz nie jest obsługiwana.",
        message: "Prosimy o zmianę używanej przeglądarki i ponowną próbę."
    };
    return(
        <Error error={errorToDisplay} />
    );
};

export default NotSupportedBrowser;


// WEBPACK FOOTER //
// ./src/components/NotSupportedBrowser/NotSupportedBrowser.js